import { RefObject, useCallback, useRef } from 'react';
import { useDragScroll } from '@srm/ui/hooks/useDragScroll';
import { useScrollState } from './useScrollState';
import { WinnerTableView } from './useTableViewMode';

const OFFER_COLUMN_WIDTH = 320; // .ws-col-offer width
const CRIT_COLUMN_WIDTH = 300; // .ws-col-critcol width (byOffer view)
const CRIT_HEAD_WIDTH = 280; // .ws-col-crit width (sticky-первый столбец, byCriteria)
const OFFER_HEAD_WIDTH = 340; // .ws-col-offerhead width (sticky-первый столбец, byOffer)

export interface IWinnerTableScroll {
    scrollRef: RefObject<HTMLDivElement | null>;
    canScrollLeft: boolean;
    canScrollRight: boolean;
    /** Ширина прокручиваемого столбца и закреплённого первого — их ждёт HorizontalPager. */
    columnWidth: number;
    firstColWidth: number;
    scrollByPage: (dir: 1 | -1, columns: number) => void;
}

/** Горизонтальный скролл таблицы выбора победителя: состояние стрелок, перетаскивание
 *  и листание страницами. Ширины столбцов заданы в SCSS — здесь их зеркало для шага. */
export function useWinnerTableScroll(view: WinnerTableView, tableData: unknown): IWinnerTableScroll {
    const scrollRef = useRef<HTMLDivElement>(null);
    const { canScrollLeft, canScrollRight } = useScrollState(scrollRef, [tableData, view]);
    useDragScroll(scrollRef, { recalcOn: [tableData, view] });
    const columnWidth = view === 'byCriteria' ? OFFER_COLUMN_WIDTH : CRIT_COLUMN_WIDTH;
    const firstColWidth = view === 'byCriteria' ? CRIT_HEAD_WIDTH : OFFER_HEAD_WIDTH;
    const scrollByPage = useCallback(
        (dir: 1 | -1, columns: number) =>
            scrollRef.current?.scrollBy({ left: dir * columnWidth * columns, behavior: 'smooth' }),
        [columnWidth],
    );

    return { scrollRef, canScrollLeft, canScrollRight, columnWidth, firstColWidth, scrollByPage };
}
